import {ACCESS_TOKEN} from "../constants/auth";
import {API_BASE_URL} from "../constants/api";
import axios from "axios";

/**
 * Курсы витрины корпоративного обучения (/courses и /courses/:slug).
 *
 * Отдельный сервис, а не CourseService: та сущность — учебный курс для договоров,
 * групп и журналов, у неё другая модель и другой жизненный цикл.
 *
 * Форма объекта совпадает с той, что раньше лежала в courses.data.js: текстовые
 * поля приходят триплетами {ru, kk, en}, поэтому витрина читает их тем же
 * useLocalizedText и никакой конвертации между API и вёрсткой не нужно.
 */
const MarketCourseService = {};

const authHeaders = () => ({
    'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
});

/** Публичный список: только видимые курсы, в редакторском порядке. */
MarketCourseService.getAll = async function () {
    const response = await axios.get(API_BASE_URL + '/api/market-course/get/all');
    return response.data;
};

/** Публичная карточка по слагу из URL. 404, если курса нет или он скрыт. */
MarketCourseService.getBySlug = async function (slug) {
    const response = await axios.get(API_BASE_URL + `/api/market-course/get/${slug}`);
    return response.data;
};

/** Админский список — вместе со скрытыми. */
MarketCourseService.getAllForAdmin = async function () {
    const response = await axios.get(API_BASE_URL + '/api/admin/market-course/get/all', {
        headers: authHeaders(),
    });
    return response.data;
};

MarketCourseService.getById = async function (id) {
    const response = await axios.get(API_BASE_URL + `/api/admin/market-course/get/${id}`, {
        headers: authHeaders(),
    });
    return response.data;
};

/** Создание и обновление одним эндпоинтом: id === null означает создание. */
MarketCourseService.save = async function (course) {
    const response = await axios.post(API_BASE_URL + '/api/admin/market-course/save', course, {
        headers: {...authHeaders(), 'Content-Type': 'application/json'},
    });
    return response.data;
};

MarketCourseService.remove = async function (id) {
    return axios.delete(API_BASE_URL + `/api/admin/market-course/delete/${id}`, {
        headers: authHeaders(),
    });
};

/** Загрузка фото преподавателя. Возвращает имя файла для поля trainer.photo. */
MarketCourseService.uploadPhoto = async function (file) {
    const data = new FormData();
    data.append('file', file);
    const response = await axios.post(API_BASE_URL + '/api/admin/market-course/photo', data, {
        headers: {...authHeaders(), 'Content-Type': 'multipart/form-data'},
    });
    return response.data;
};

/** Публичный URL фото преподавателя по имени файла из trainer.photo. */
MarketCourseService.photoUrl = (fileName) =>
    (fileName ? `${API_BASE_URL}/api/market-course/photo/${fileName}` : null);

export default MarketCourseService;
